
import React, { useRef, useEffect } from 'react'
import useState from 'react-usestateref'

import styles from './image.module.sass'

import classNames from 'classnames'

import get from 'lodash/get'

import BlockWrapper from '../layout/block_wrapper'


function Image(props) {
	let fields = get(props, 'fields.image', props) || props.fields || null
	let settings = props.settings
	let classes = ''
	let style = ''
	let url = fields?.url || props.url

	if (!fields || !fields?.url) {
		console.log('No image fields')
		return '<div>Image issue</div>'
	}

	const svg = fields.mime_type != 'image/svg+xml' && fields.url.slice(-4) != '.svg' ? false : true

	const [sizes, setSizes] = useState(svg ? true : '')
	const [loaded, setLoaded] = useState(false)
	const imageRef = useRef(null)

	const displayedFields = {
		alt: fields.alt,
		width: fields.width == '1' ? 'auto' : fields.width,
		height: fields.height == '1' ? 'auto' : fields.height,
		loading: settings?.loading || 'lazy',
		style: {objectPosition: fields.alignment, ...props.style}
	}

	if(settings?.transition == 'none'){
		classes += ' ' + styles.no_transition
	}

	useEffect(() => {
		if (imageRef.current && !svg) {
			setSizes(props.sizeOverride || (imageRef.current.offsetWidth + 'px'))
		}
	}, [imageRef])

	const handleLoad = () => {
		setLoaded(true)
	}

	let srcset = []
	let mobileSizes = []
	let desktopSizes = []
	let allSizes = []

	if (!svg) {
		for (const key in fields.sizes) {
			if (key.slice(-6) == '-width') {
				if (fields.sizes[key] > 768) {
					desktopSizes.push(fields.sizes[key] + 'px')
				} else {
					mobileSizes.push(fields.sizes[key] + 'px')
				}
				allSizes.push(fields.sizes[key] + 'px')
			} else if (key.slice(-7) == '-height') {
				continue
			} else {
				srcset.push(fields.sizes[key] + ' ' + fields.sizes[key + '-width'] + 'w')
			}
		}
	}

	srcset = srcset.join(',')

	function renderImage(){
		return <>
			<img ref={imageRef} className={classNames(classes, loaded ? styles.loaded : '', fields.mime_type == 'image/svg+xml' ? styles.svg : '')} src={sizes ? url : ''} srcSet={sizes ? srcset : ''} sizes={sizes && sizes !== true ? sizes : ''} onLoad={handleLoad} {...(loaded ? { 'data-loaded': 'true' } : {})} {...displayedFields} />
		</>
	}

	if (props.layout_settings || props.fields?.layout_settings) {
		return <BlockWrapper {...props} className={classNames(styles.image, fields.mobile == true ? styles.mobile_version : '', fields.className, styles[props.fields?.custom_class])}>
			{props.fields?.link_url && <a href={props.fields?.link_url} target={props.fields?.link_target ? '_blank' : ''}>
				{renderImage()}
			</a>}
			{!props.fields?.link_url && renderImage()}
		</BlockWrapper>
	} else {
		return <div className={classNames(styles.image, fields.mobile == true ? styles.mobile_version : '', fields.className, styles[props.fields?.custom_class])}>
			{props.fields?.link_url && <a href={props.fields?.link_url} target={props.fields?.link_target ? '_blank' : ''}>
				{renderImage()}
			</a>}
			{!props.fields?.link_url && renderImage()}
		</div>
	}
}

export default Image